/* Reconstructed from tenant.zip:public/build/assets/chunk-CMxvf4Kt.js
 * Original SHA-256: 101087c385ddfea7c37eb72790fd5aa7a3d647e85dc24171c830034ed27d3c90
 * Surviving compiled logic, formatted and relinked. Original templates/comments/names are not recovered.
 */
var e = Object.create,
  t = Object.defineProperty,
  n = Object.getOwnPropertyDescriptor,
  r = Object.getOwnPropertyNames,
  i = Object.getPrototypeOf,
  a = Object.prototype.hasOwnProperty,
  o = (e, t) => () => (e && (t = e((e = 0))), t),
  s = (e, t) => () => (
    t ||
      (e(
        (t = {
          exports: {},
        }).exports,
        t,
      ),
      (e = null)),
    t.exports
  ),
  c = (e, n) => {
    let r = {};
    for (var i in e)
      t(r, i, {
        get: e[i],
        enumerable: !0,
      });
    return (
      n ||
        t(r, Symbol.toStringTag, {
          value: `Module`,
        }),
      r
    );
  },
  l = (e, i, o, s) => {
    if ((i && typeof i == `object`) || typeof i == `function`)
      for (var c = r(i), l = 0, u = c.length, d; l < u; l++)
        ((d = c[l]),
          !a.call(e, d) &&
            d !== o &&
            t(e, d, {
              get: ((e) => i[e]).bind(null, d),
              enumerable: !(s = n(i, d)) || s.enumerable,
            }));
    return e;
  },
  u = (n, r, a) => (
    (a = n == null ? {} : e(i(n))),
    l(
      r || !n || !n.__esModule
        ? t(a, `default`, {
            value: n,
            enumerable: !0,
          })
        : a,
      n,
    )
  ),
  d = (e) =>
    a.call(e, `module.exports`)
      ? e[`module.exports`]
      : l(
          t({}, `__esModule`, {
            value: !0,
          }),
          e,
        ),
  f = ((e) =>
    typeof require < `u`
      ? require
      : typeof Proxy < `u`
        ? new Proxy(e, {
            get: (e, t) => (typeof require < `u` ? require : e)[t],
          })
        : e)(function (e) {
    if (typeof require < `u`) return require.apply(this, arguments);
    throw Error(
      'Calling `require` for "' +
        e +
        "\" in an environment that doesn't expose the `require` function. See https://rolldown.rs/in-depth/bundling-cjs#require-external-modules for more details.",
    );
  });
export { d as a, f as i, o as n, u as o, c as r, s as t };
